export default "__VITE_ASSET__BIWjQH53__"